import { useEffect, useMemo, useState } from 'react';
import { useAuthentication } from 'src/features/authentication/context';
import { ReadingEventMessage } from 'src/types/readings/readings';
import { TagResponse } from 'src/types/tags/tags';
import { setLiveDataMessages } from 'src/utilities/setLiveDataMessages';

type Props = {
  selectedTagIds: { id: string; position: number }[];
  gatewayInputs: TagResponse[];
  messages: ReadingEventMessage;
};

export const useLiveData = ({ selectedTagIds, gatewayInputs, messages }: Props) => {
  const {
    siteId: { value: siteId },
  } = useAuthentication();
  const [newLiveData, setNewLiveData] = useState<any>([]);

  const tags = useMemo(() => {
    const filteredTags = gatewayInputs?.filter((item: any) =>
      selectedTagIds?.some((tag) => tag.id === item.id)
    );

    return filteredTags?.sort((a: any, b: any) => {
      const posA = selectedTagIds?.find((tag) => tag.id === a.id)?.position || 0;
      const posB = selectedTagIds?.find((tag) => tag.id === b.id)?.position || 0;
      return posA - posB;
    });
  }, [gatewayInputs, selectedTagIds]);

  const formttedTags = useMemo(
    () => tags?.map((item: any) => ({ tagId: item.id, ...item })),
    [tags]
  );

  const isLiveDataMessages = messages?.data;
  const siteIdFromLiveData = messages?.data?.siteId;
  const sourceIdFromLiveData = messages?.data?.sourceId;

  const isSourceIdIncludedInSelectedTagsList = formttedTags?.find(
    (tag: any) => tag.gatewayId === sourceIdFromLiveData
  );

  useEffect(() => {
    if (
      siteIdFromLiveData === siteId &&
      isLiveDataMessages &&
      isSourceIdIncludedInSelectedTagsList
    ) {
      setNewLiveData((prevState: ReadingEventMessage[]) =>
        setLiveDataMessages(prevState, messages)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages, siteId]);

  const combinedInputs = useMemo(
    () => newLiveData?.reduce((acc: any, item: any) => acc.concat(item.data.data), []),
    [newLiveData]
  );

  const liveDataComplete = useMemo(
    () => ({
      siteId: undefined,
      tags: combinedInputs,
    }),
    [combinedInputs]
  );
  return {
    formttedTags: formttedTags,
    liveDataComplete: liveDataComplete,
  };
};
